module.exports = __webpack_public_path__ + "static/IMG_3804-4e314c3bfaf295ac3110a82ecfa1f874.jpg";